import React from 'react';

const Logistic = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='49'
			height='48'
			fill='none'
			viewBox='0 0 49 48'
		>
			<path
				fill='#2d2d2d'
				d='M24.035 39C17.09 39 11.24 33.39 11 26.295V16.5c0-1.65 1.35-3 3-3h1.5v3H14v9.75c.18 5.535 4.83 9.915 10.455 9.75 5.625.15 10.365-4.215 10.545-9.795V10.5h-1.5v-3H35c1.65 0 3 1.35 3 3v15.75C37.76 33.39 31.91 39 24.875 39h-.84z'
			></path>
			<path
				fill='#2d2d2d'
				d='M32 21h-3V6h-1.5V3H29c1.65 0 3 1.35 3 3v15zM20 21h-3V6h-1.5V3H17c1.65 0 3 1.35 3 3v15zM26 21h-3V3h-1.5V0H23c1.65 0 3 1.35 3 3v18zM35 45H14v3h21v-3z'
			></path>
		</svg>
	);
};

export default Logistic;
